document.querySelectorAll('.BannerSlider').forEach((container) => {
    tns({
        container: container.children[0],
        items: 1,
        nav: true,
        mouseDrag: true,
        controls: false,
        loop: true,
        responsive: {
            768: {
                controls: true,
            },
        },
    }).then((slider) => {
        const aboutEl = container.querySelector('.BannerSlider__about');
        slider.events.on('indexChanged', (e) => {
            aboutEl.innerHTML = e.slideItems[e.index].dataset.about;
        });
    });
})
